import { TProductParams } from 'feature/appeals/type'
import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Checkbox, FormControlLabel } from 'ui'

interface IInputCheckbox {
  parameter: TProductParams
}

// параметр продукта с типом сheckbox
export const InputCheckbox: FC<IInputCheckbox> = ({ parameter }) => {
  const { control } = useFormContext()
  const { parameterValue, name, id } = parameter
  return (
    <div>
      <Controller
        name={`${id}`}
        control={control}
        defaultValue={parameterValue?.value || false}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} name={name} checked={field.value} />}
            label={name}
          />
        )}
      />
    </div>
  )
}
